angular = require('angular')

app = angular.module('workflow.app')
app.controller('EditWorkflowController', require './EditWorkflowController')
app.directive('editWorkflow', ->
  return {
    controller: 'EditWorkflowController'
    template: require('./edit-workflow.html')
  }
)
